import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuyBezpieczneZakupy() {
  return <ArticleLayout article={articlesBySlug['kakobuy-bezpieczne-zakupy']} />;
}